import {
  Component, OnInit, ElementRef, forwardRef, Input, OnChanges, Output, EventEmitter,
  Renderer2, OnDestroy, Self, Query, QueryList, Directive, Provider, ViewEncapsulation, NgModule, SimpleChanges
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {  CustomCodeValuesController, CustomCodeTypeRequest } from './customdatabyrequesttype.interface';
import { CUstomDataByRequestTypeService } from './customdatabyrequesttype.service';
import { Router } from '@angular/router';

import {
  NG_VALUE_ACCESSOR
  , ControlValueAccessor
  , SelectControlValueAccessor
} from '@angular/forms';
import { AppData } from '../../models/appdata';
import { ApiResponseModel } from '../../models/api_response_model';



const noop = () => {
};


export const CUSTUM_CodeTypeDDL_Value_ACCESSOR: any =
  {
    provider: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CustomDataByRequestTypeComponent),
    multi: true
  };


@Component({

  selector: 'CustomDataByRequestType',

  templateUrl: './customdatabyrequesttype.componenet.html',
  providers: [CUstomDataByRequestTypeService
    //, CUSTUM_CodeTypeDDL_Value_ACCESSOR
    ,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDataByRequestTypeComponent),
      multi: true
    }

  ],








})
export class CustomDataByRequestTypeComponent implements OnInit, OnChanges
  , ControlValueAccessor
{
    ngOnChanges(changes: SimpleChanges) {
        let shouldRefresh = false;
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                const change = changes[propName];
                if (!change.firstChange && change.currentValue !== change.previousValue) {
                    shouldRefresh = true;
                }
            }
        }
        if (shouldRefresh) {
            this.refreshAndLoadData();
        }
    }

    refreshAndLoadData() {
        if (!this.CurrentCustomCodeTypeRequest) {
            this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
        }
        this.CurrentCustomCodeTypeRequest.RequestedType = this.RequestedType;
        this.CurrentCustomCodeTypeRequest.FacilityCode = Number(this.FacilityCode) || 0;
        this.CurrentCustomCodeTypeRequest.ActorCode = Number(this.ActorCode) || 6;
        this.CurrentCustomCodeTypeRequest.CustomCode = Number(this.CustomCode) || 0;
        this.CurrentCustomCodeTypeRequest.CustomType = this.CustomType || "0";
        this.CurrentCustomCodeTypeRequest.StringContains = this.StringContains || "0";
        this.CurrentCustomCodeTypeRequest.MedicineCode = Number(this.MedicineCode) || 0;
        const apiModel = AppData.Instance().ApiRequestParms || { xUserName: 'admin', xAuthGenKEY: '' } as any;
        this.CurrentCustomCodeTypeRequest.SendApiRequestModel = apiModel;
        if (!this.CurrentCustomCodeTypeRequest.SendApiRequestModel.xUserName) {
            this.CurrentCustomCodeTypeRequest.SendApiRequestModel.xUserName = 'admin';
        }
        this.RequestedTypeValueByType();
    }
  //http://almerosteyn.com/2016/04/linkup-custom-control-to-ngcontrol-ngmodel
  // ------------------------------------

  private innerValue: any = '';
  public isRequesting: boolean = false;
  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;
  //private onChangeCallback(obj: any) {

  //  this.valueChanged.emit(obj);

  //}
  RequestedTypeValueArray: Array<string>;
  public SelectedDDLValue: string;

    public key: string;
    public searchKey: string;


    @Input()
    get SearchKey() {
        return this.searchKey;
    }

  @Input()
  get Key() {
    return this.key;
    }
    set SearchKey(value: string) {
        this.searchKey = value;
        this.searchKeyChange.emit(this.searchKey);
    }
  @Output() valueChanged = new EventEmitter();
    @Output() keyChange = new EventEmitter();
  @Output() searchKeyChange = new EventEmitter();
  @Output() dataLoaded = new EventEmitter();
  @Output() loadedData = new EventEmitter();
  set Key(value: string) {
    this.key = value;
    //  alert(this.Key);       
      this.keyChange.emit(this.key);
      //this.searchKeyChange.emit(this.searchKey);
  }


  //get accessor
  get value(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }



  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
  //------------------------------------------


  //registerOnTouched(fn: any) {
  //    this.onTouchedCallback = fn;

  //}
  onChange(Event: any) {
    console.log("----Event----------------" + Event);
    if (Event != null && this.CurrentCustomCodeValuesController) {
      var a = this.CurrentCustomCodeValuesController.filter(x => 
        (x.Code != null && x.Code == Event) || 
        ((x as any).code != null && (x as any).code == Event) ||
        (x.Code != null && x.Code === parseInt(Event))
      );
      if (a.length > 0) {
        this.Key = a[0].DisplayName || (a[0] as any).displayName;
        this.SearchKey = a[0].SearchName || (a[0] as any).searchName;
      } else {
        this.key = "";
        this.searchKey = "";
      }
    }
    this.innerValue = Event;
    this.onTouchedCallback();
    this.onChangeCallback(this.innerValue);
    console.log(this.innerValue);
  }

  //***********************************/

  //@Input() IsSelected: boolean =false;
  @Input() SelectedValue: string = "";
  @Input() public DisplayLabelText: string = "";
  @Input() public DisplayDefaultValue: string = "";
  @Input() public FontSize: number = 14;//"16px"
  @Input() public Height: number = 2.25;
  @Input() RequestedType: string;
  @Input() public FacilityCode: number = 0;
  @Input() public ActorCode: number = 0;
    @Input() public CustomCode: number = 0;
    @Input() public ShouldLoadByParent: boolean = false
  //@Input() public TestCode: number = 0;
  @Input() public MedicineCode: number = 0;
  @Input() public CustomType: string = "0";
    @Input() public StringContains: string = "0";

  public ApiResData: ApiResponseModel;

  CurrentCustomCodeTypeRequest: CustomCodeTypeRequest;
  CurrentCustomCodeValuesController: CustomCodeValuesController[];

  constructor(
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    public _router: Router, public CUstomDataByRequestTypeService: CUstomDataByRequestTypeService) {
  }

  ngOnInit() {
    this.CurrentCustomCodeTypeRequest = new CustomCodeTypeRequest();
    this.CurrentCustomCodeTypeRequest.RequestedType = this.RequestedType;
    this.CurrentCustomCodeTypeRequest.FacilityCode = Number(this.FacilityCode) || 0;
    this.CurrentCustomCodeTypeRequest.ActorCode = Number(this.ActorCode) || 6;
    this.CurrentCustomCodeTypeRequest.CustomCode = Number(this.CustomCode) || 0;
    this.CurrentCustomCodeTypeRequest.CustomType = this.CustomType;
    this.CurrentCustomCodeTypeRequest.StringContains = this.StringContains;
    this.CurrentCustomCodeTypeRequest.MedicineCode = Number(this.MedicineCode) || 0;
    const apiModel = AppData.Instance().ApiRequestParms || { xUserName: 'admin', xAuthGenKEY: '' } as any;
    this.CurrentCustomCodeTypeRequest.SendApiRequestModel = apiModel;
    if (!this.CurrentCustomCodeTypeRequest.SendApiRequestModel.xUserName) {
      this.CurrentCustomCodeTypeRequest.SendApiRequestModel.xUserName = 'admin';
    }
    this.CurrentCustomCodeValuesController = new Array<CustomCodeValuesController>();

    if (this.DisplayDefaultValue != "" && this.DisplayDefaultValue != null) {
      this.SelectedDDLValue = this.DisplayDefaultValue;
      //alert(result);
      this.innerValue = this.DisplayDefaultValue;
      this.onTouchedCallback();
      this.onChangeCallback(this.innerValue);
      console.log(this.innerValue);
    }

    this.RequestedTypeValueByType();

  }

    RefreshData(parentCode: number) {
       // alert(parentCode);
        if (this.ShouldLoadByParent) {
            this.CurrentCustomCodeTypeRequest.CustomCode = parentCode;
            this.RequestedTypeValueByType();
        }
    }



    RequestedTypeValueByType(): void {

    this.StartRefreshing();

    this.CUstomDataByRequestTypeService.GetCustomDataByRequestedType(this.CurrentCustomCodeTypeRequest).subscribe
      (
    
       (result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          const rawResult = this.ApiResData.Result || (this.ApiResData as any).result || [];
          this.CurrentCustomCodeValuesController = rawResult;
          if (rawResult.length > 0) {
            const firstItem = rawResult[0];
            const firstCode = firstItem.Code != null ? firstItem.Code : firstItem.code;
            const firstName = firstItem.DisplayName || firstItem.displayName || firstItem.SearchName || firstItem.searchName;
            if (this.innerValue === '' || this.innerValue === null || this.innerValue === undefined || this.innerValue === 0) {
              this.innerValue = firstCode;
              this.onChangeCallback(firstCode);
            }
            this.Key = firstName;
            this.SearchKey = firstItem.SearchName || firstItem.searchName || firstName;
          }
          this.dataLoaded.emit(this.RequestedType);
          this.loadedData.emit(this.CurrentCustomCodeValuesController);
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            alert(' Failed Due to Internal Error.... Please Contact Admin..');
          }
        }

      },
      (error) => {

        if (error == "401 - Unauthorized") {
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
        }
      }
      //
      );;

  }
  private stopRefreshing() {
    this.isRequesting = false;

  }
  private StartRefreshing() {
    this.isRequesting = true;

  }



}
